export const EXCEL_DATA_RESET = "EXCEL_DATA_RESET";
export const EXCEL_SET_DATA = "EXCEL_SET_DATA";
export const EXCEL_SET_TAB = "EXCEL_SET_TAB";
export const EXCEL_SET_ITEMS = "EXCEL_SET_ITEMS";
